module.exports = __webpack_public_path__ + "static/media/killam.4aa4bd5c.png";